export default __webpack_public_path__ + "images/173e5d6957b92e4c6b791165cb68ada8.png";